"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveToPage = exports.changePage = exports.updatePageDetails = exports.setEditMode = exports.updateCurrentApp = exports.MOVE_TO_PAGE = exports.UPDATE_PAGE_DETAILS = exports.SET_EDIT_MODE = exports.UPDATE_CURRENT_APP = void 0;

var _reactRouterRedux = require("react-router-redux");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


var UPDATE_CURRENT_APP = 'UPDATE_CURRENT_APP';
exports.UPDATE_CURRENT_APP = UPDATE_CURRENT_APP;
var SET_EDIT_MODE = 'SET_EDIT_MODE';
exports.SET_EDIT_MODE = SET_EDIT_MODE;
var UPDATE_PAGE_DETAILS = 'UPDATE_PAGE_DETAILS';
exports.UPDATE_PAGE_DETAILS = UPDATE_PAGE_DETAILS;
var MOVE_TO_PAGE = 'MOVE_TO_PAGE';
exports.MOVE_TO_PAGE = MOVE_TO_PAGE;

var updateCurrentApp = function updateCurrentApp(name) {
  return {
    type: UPDATE_CURRENT_APP,
    name: name
  };
};

exports.updateCurrentApp = updateCurrentApp;

var setEditMode = function setEditMode(editState) {
  return {
    type: SET_EDIT_MODE,
    editState: editState
  };
}; // update store with new page values based on some cta to navigate
// this gets batched with changePage and is called directly before that action


exports.setEditMode = setEditMode;

var updatePageDetails = function updatePageDetails(location) {
  return {
    type: UPDATE_PAGE_DETAILS,
    location: location
  };
}; // this will actually navigate to a new page (really just renders a new component)
// location will be passed from the cta that wants to navigate ... it will match up to a route in app.js which will transition to that new component
// behind the scenes this will be synced with the history object we created so there is standard browser functionality in place
// this gets batched with updatePage and is called directly after that action
// NO reducer for this, instead we're just using a module to "push" the new location


exports.updatePageDetails = updatePageDetails;

var changePage = function changePage(location) {
  return (0, _reactRouterRedux.push)("/".concat(location === undefined ? '' : location));
};

exports.changePage = changePage;

var moveToPage = function moveToPage(location) {
  return {
    type: MOVE_TO_PAGE,
    location: location
  };
};

exports.moveToPage = moveToPage;